import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      refreshToken: 'refreshToken',
    }),
  },
  mounted() {
    if (this.isLoggedIn) {
      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) {
            return;
          }
          this.$store.dispatch('user/refreshToken');
        },
        false,
      );
      if (this.refreshToken) {
        setInterval(() => {
          this.$store.dispatch('user/refreshToken');
        }, 600000); // every 10 minutes
      }
      this.checkAddressFormCheck();
    }
  },
  methods: {
    async checkAddressFormCheck() {
      const addressFormCheck = this.$store.getters.getApiLink('payment.addressFormCheck');
      if (addressFormCheck) {
        const { data } = await this.$api.get(addressFormCheck);
        if (data?.enabled) {
          this.$router.push('/billing-address');
        }
      }
    },
  },
};
